export default __webpack_public_path__ + "static/media/banner449East.a3acb150.jpg";